export const domainSize =  {
    "s0": "0mm",
    "s25": "25mm",
    "s50": "50mm",
    "s75": "75mm",
    "s100": "100mm",
    "s110": "110mm",
    "s120": "120mm",
    "s125": "125mm",
    "s150": "150mm",
    "s155":"155mm",
    "s160": "160mm",
    "s180":"180mm",
    "s200": "200mm",
    "s225": "225mm",
    "s250": "250mm",
    "s280": "280mm",
    "s300": "300mm",
    "s350": "350mm",
    "s355": "355mm",
    "s375": "375mm",
    "s400": "400mm",
    "s450": "450mm",
    "s460": "460mm",
    "s500": "500mm",
    "s525": "525mm",
    "s600": "600mm",
    "s630": "630mm",
    "s650": "650mm",
    "s700": "700mm",
    "s750": "750mm",
    "s800": "800mm",
    "s350": "350mm",
    "s19": "19mm",
    "s32": "32mm",
    "s63": "63mm",
    "s900": "900mm",
    "s80": "80mm",
    "s315": "315mm",
    "s215": "215mm",
    "s335": "335mm",
    "s255": "255mm",
    "s280": "280mm",
    "s260": "260mm",
    "s226": "226mm",
    "s62": "62mm",
    "s90": "90mm",
    "s92": "92mm"
  }
